import remarkGfm from 'remark-gfm'
import rehypeKatex from 'rehype-katex'
import remarkMath from 'remark-math'
import remarkParse from 'remark-parse'
import remarkRehype from 'remark-rehype'
import rehypeStringify from 'rehype-stringify'
import { unified } from 'unified'

const markdownProcessor = unified()
    .use(remarkParse)
    .use(remarkGfm)
    .use(remarkMath)
    .use(remarkRehype)
    .use(rehypeKatex, {
        output: 'html',
        strict: false,
        trust: true,
    })
    .use(rehypeStringify)

export const convertMarkdownToHTML = (markdown: string) => {
    return markdownProcessor.processSync(markdown).toString()
}
